
<div id="footer">
    <div class="alignleft">
        <a class="pointer-cursor" fxHide.xs fxHide.sm>@ {{currentDate| date:'yyyy'}} iWorkGlobal</a>
        <a class="no-margin  pointer-cursor" fxHide.gt-sm>@ {{currentDate| date:'yyyy'}}</a>
        <span class="delimiter">|</span>
        <a class="pointer-cursor" (click)="showTermsOfUse($event)">Terms of Use</a>
        <span class="delimiter">|</span>
        <a href="http://www.iworkglobal.com/privacy-full/" target="_blank" class="pointer-cursor">Data Privacy</a>
    </div>

    <div class="alignright">
        <a class="pointer-cursor" fxHide.xs fxHide.sm>415-800-5980</a>
        <span class="delimiter" fxHide.xs>|</span>
        <a (click)="showContactUs($event)">Contact Us</a>
    </div>
</div>
